import { PaginationRequest, PaginationResponse } from "@shared/api/types"
import { StateCreator } from "zustand"

const INITIAL_LIMIT = 10
const INITIAL_SKIP = 0
const INITIAL_TOTAL_COUNT = 0

const INITIAL_PAGINATION_REQUEST: PaginationRequest = {
	limit: INITIAL_LIMIT,
	skip: INITIAL_SKIP,
}

export type PaginationState = {
	limit: number
	skip: number
	totalCount: number
	filteredCount: number
	canLoadMore: boolean
	paginationRequest: PaginationRequest
}

export type PaginationActions = {
	updatePagination: (
		pagination: PaginationResponse,
		availableCount: number,
	) => void
	updatePaginationPageStats: (skip: number, limit: number) => void
	resetPagination: () => void
}

export const usePaginationStore: StateCreator<
	PaginationState & PaginationActions
> = set => ({
	limit: INITIAL_LIMIT,
	skip: INITIAL_SKIP,
	totalCount: INITIAL_TOTAL_COUNT,
	filteredCount: INITIAL_TOTAL_COUNT,
	canLoadMore: true,
	paginationRequest: INITIAL_PAGINATION_REQUEST,

	updatePagination: (
		pagination: PaginationResponse,
		availableCount: number,
	) => {
		set(() => ({
			limit: pagination.limit,
			skip: pagination.skip,
			totalCount: pagination.totalCount,
			filteredCount: pagination.filteredCount,
			canLoadMore:
				pagination.hasMore || pagination.filteredCount > availableCount,
			paginationRequest: {
				limit: pagination.limit,
				skip: pagination.skip + pagination.limit,
			},
		}))
	},
	updatePaginationPageStats: (skip: number, limit: number) =>
		set(() => ({
			skip,
			limit,
			canLoadMore: true,
			paginationRequest: {
				skip,
				limit,
			},
		})),
	resetPagination: () =>
		set(() => ({
			limit: INITIAL_LIMIT,
			skip: INITIAL_SKIP,
			totalCount: INITIAL_TOTAL_COUNT,
			filteredCount: INITIAL_TOTAL_COUNT,
			canLoadMore: true,
			paginationRequest: INITIAL_PAGINATION_REQUEST,
		})),
})
